import {
  GeographyFilter,
  GeographyFilterPayload,
  ReportsGeographyFilter,
  ReportsGeographyFilterPayload,
  PollingGeoCounts,
  PollingGeoCountsPayload,
} from 'src/@types/geographyFilters';
import { useGet } from './templateHooks';
import { FAST_API_URL } from 'src/config';

export const useGeographyFilters = (params: GeographyFilterPayload, config = {}) =>
  useGet<GeographyFilter, GeographyFilterPayload>({
    //fix backend endpoint to only return data
    queryKey: ['geographyFilters'],
    endpoint: '/v1/geography/search',
    config: config,
    params: params,
    url: FAST_API_URL,
    requiresAuth: false,
  });

export const useReportsGeographyFilters = (params: ReportsGeographyFilterPayload, config = {}) =>
  useGet<ReportsGeographyFilter[], ReportsGeographyFilterPayload>({
    queryKey: ['ReportsGeographyFilters'],
    endpoint: '/v1/reports/geography-filters',
    config: config,
    params: params,
    url: FAST_API_URL,
  });

export const usePollingGeoCounts = (params: PollingGeoCountsPayload, config = {}) =>
  useGet<PollingGeoCounts, PollingGeoCountsPayload>({
    queryKey: ['pollingGeoCounts', params.org_id, params.voter_filter_id],
    endpoint: '/v1/geography/polling-geo-counts',
    config: config,
    params: params,
    url: FAST_API_URL,
  });
